import { ICommonRequest } from "../../../model/request/ICommonRequest";
import { IHocSinhComboRequest } from "../../../model/request/set-tieu-chuan/IHocSinhComboRequest";
import { IHocSinhSelectRequest } from "../../../model/request/set-tieu-chuan/IHocSinhSelectRequest";
import { IHocSinhViewModel } from "../../../model/respone/category/IHocSinhViewModel";
import { ISetTieuChuanHocSinh } from "../../../model/respone/set-tieu-chuan/ISetTieuChuanHocSinh";
import { ISetTieuChuanHocSinhViewModel } from "../../../model/respone/set-tieu-chuan/ISetTieuChuanHocSinhViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

interface ISetTieuChuanHocSinhHtmlPrintPayload {
    id: number,
    data: string
}

export const eSetTieuChuanHocSinhActionTypeDefine = {
    LOAD_START: {} as ICommonRequest,
    LOAD_SUCCESS: {} as ISetTieuChuanHocSinhViewModel[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | ISetTieuChuanHocSinh,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ISetTieuChuanHocSinh,
    SAVE_SUCCESS: {} as ISetTieuChuanHocSinh,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    UPDATE_PHAT_DONG_PHUC_START: {} as { id: number, daPhatDongPhuc: boolean },
    UPDATE_PHAT_DONG_PHUC_SUCCESS: {} as ISetTieuChuanHocSinhViewModel,
    UPDATE_PHAT_DONG_PHUC_ERROR: "",

    SHOW_ADD_COMBO_MODAL: {} as boolean,
    CLOSE_ADD_COMBO_MODAL: undefined,

    SAVE_ADD_COMBO_START: {} as IHocSinhComboRequest,
    SAVE_ADD_COMBO_SUCCESS: {} as ISetTieuChuanHocSinhViewModel[],
    SAVE_ADD_COMBO_ERROR: "",

    LOAD_HOCSINH_START: {} as IHocSinhSelectRequest,
    LOAD_HOCSINH_SUCCESS: {} as IHocSinhViewModel[],
    LOAD_HOCSINH_ERROR: "",

    CHANGED_HOCSINH_SELECTED_IDS: {} as number[],
    CHANGED_TRUONG_SELECTED_IDS: {} as number[],
    CHANGED_KHOI_SELECTED_IDS: {} as number[],
    CHANGED_HE_SELECTED_IDS: {} as number[],
    CHANGED_LOP_SELECTED_IDS: {} as number[],
    CHANGED_COMBO_SELECTED_ID: {} as number,
    CHANGED_GIOITINH_SELECTED_IDS: {} as number[],
    CHANGED_TRANGTHAI_SELECTED_IDS: {} as number[],

    LOAD_COMBO_PENDING_START: 0,
    LOAD_COMBO_PENDING_SUCCESS: {} as ISetTieuChuanHocSinhViewModel[],
    LOAD_COMBO_PENDING_ERROR: "",

    GET_HTML_PRINT_START: 0,
    GET_HTML_PRINT_SUCCESS: {} as ISetTieuChuanHocSinhHtmlPrintPayload,
    GET_HTML_PRINT_ERROR: {} as ISetTieuChuanHocSinhHtmlPrintPayload,

}

export const eSetTieuChuanHocSinhActionTypeIds = generateActionTypeIds(eSetTieuChuanHocSinhActionTypeDefine, "SET_TIEU_CHUAN_HOC_SINH");

export type ISetTieuChuanHocSinhActions = IGenericActionType<typeof eSetTieuChuanHocSinhActionTypeDefine, "SET_TIEU_CHUAN_HOC_SINH">;